import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const COLOR_PALETTE = [
  "#4f46e5", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
  "#3b82f6", "#14b8a6", "#eab308", "#f87171", "#a855f7"
];

const normalizeKey = (key) => key.trim().toLowerCase();

const BarChartSales = ({ data }) => {
  const months = Object.keys(data || {});
  if (months.length === 0) {
    return (
      <div style={{
        height: "300px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px dashed #ccc",
        borderRadius: "2px"
      }}>
        <p>No data available for the chart</p>
      </div>
    );
  }

  // Extract all unique source types (normalized)
  const sourcesMap = {};
  months.forEach(month => {
    const entries = data[month] || {};
    Object.keys(entries).forEach(key => {
      const normalized = normalizeKey(key);
      if (!sourcesMap[normalized]) {
        sourcesMap[normalized] = key; // Save original casing
      }
    });
  });
  const uniqueSources = Object.keys(sourcesMap);

  // Prepare datasets
  const datasets = uniqueSources.map((source, idx) => {
    const label = sourcesMap[source];
    return {
      label,
      data: months.map(month => {
        const value = Object.entries(data[month] || {}).find(
          ([key]) => normalizeKey(key) === source
        );
        return value ? value[1] : 0;
      }),
      backgroundColor: COLOR_PALETTE[idx % COLOR_PALETTE.length],
      borderColor: COLOR_PALETTE[idx % COLOR_PALETTE.length],
      borderWidth: 1,
      borderRadius: 4,
      barPercentage: 0.8,
      categoryPercentage: 0.8
    };
  });

  const chartData = {
    labels: months,
    datasets
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 8,
          padding: 8,
          font: { size: 9 },
        },
      },
      tooltip: {
        bodyFont: { size: 9 },
        backgroundColor: "#1f2937",
        titleColor: "#f9fafb",
        bodyColor: "#f9fafb",
        borderColor: "#4b5563",
        borderWidth: 1,
        padding: 12,
        callbacks: {
          title: (tooltipItems) => `Month: ${tooltipItems[0].label}`,
          label: (context) => `${context.dataset.label}: ₹${context.raw?.toLocaleString()}`,
        },
      },
    },
    scales: {
      x: {
        ticks: { font: { size: 8 } },
      },
      y: {
        ticks: {
          font: { size: 8 },
          callback: (value) => `₹${value / 1000}K`
        },
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
  };

  return (
    <div style={{ height: '240px', padding: '8px' }}>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default BarChartSales;
